<!-- <img
  class=" image d-flex justify-content-center m-auto"
  [src]="src"
  alt="image"
/> -->
<div
  class="image-container d-flex justify-content-end align-items-start"
  [style.background-image]="'url(' + src + ')'"
  [ngClass]="'modal-' + width"
>
  <i class="bx bx-x-circle fs-2 m-2 text-danger" (click)="closePopup()"></i>
</div>
